import types from "../actionTypes";

export default (
  state = {
    maxSteps: 0,
    minSteps: 0,
    step: 1,
    city: undefined,
    state: undefined,
    country: undefined,
    prefferedLanguage: undefined,
    employmentStatus: undefined,
    planLink: undefined,
    isSearch: false,
    location: undefined,
    department: undefined,
    supervisorList: undefined,
    region: undefined,
    clientInfo: undefined,
    clientInfoById: undefined,
    job: undefined,
    attachment: [],
    isAdded: false,
    ersFormPdfLink: undefined,
    stdEmployeeStatement:[]
  },
  action
) => {
  switch (action.type) {
    case types.SET_CURRENT_STEP:
      return Object.assign({}, state, { step: action.step });
    case types.SET_MAX_STEPS:
      return Object.assign({}, state, { maxSteps: action.maxSteps });
    case types.SET_MIN_STEPS:
      return Object.assign({}, state, { minSteps: action.minSteps });
    case types.SET_COUNTRY:
      return Object.assign({}, state, {
        country: action.country,
      });
    case types.SET_CITY:
      return Object.assign({}, state, {
        city: action.city,
      });
    case types.SET_STATE:
      return Object.assign({}, state, {
        state: action.state,
      });
    case types.SET_PREFFERED_LANG:
      return Object.assign({}, state, {
        prefferedLanguage: action.prefferedLanguage,
      });
    case types.SET_EMPLOYMENT_STATUS:
      return Object.assign({}, state, {
        employmentStatus: action.employmentStatus,
      });
    case types.SET_PLAN_LINK:
      return Object.assign({}, state, {
        planLink: action.planLink,
      });
    case types.SET_IS_SEARCH:
      return Object.assign({}, state, {
        isSearch: action.isSearch,
      });
    case types.SET_LOCATION:
      return Object.assign({}, state, {
        location: action.location,
      });
    case types.SET_DEPARTMENT:
      return Object.assign({}, state, {
        department: action.department,
      });
    case types.SET_SUPERVISOR_LIST:
      return Object.assign({}, state, {
        supervisorList: action.supervisorList,
      });
    case types.SET_REGION:
      return Object.assign({}, state, {
        region: action.region,
      });
    case types.SET_CLIENT_INFO:
      return Object.assign({}, state, {
        clientInfo: action.clientInfo,
      });
    case types.SET_CLIENT_INFO_BY_ID:
      return Object.assign({}, state, {
        clientInfoById: action.clientInfoById,
      });
    case types.SET_JOB:
      return Object.assign({}, state, {
        job: action.job,
      });
    case types.SET_ATTACHMENT:
      return Object.assign({}, state, {
        attachment: action.attachment,
      });
    case types.SET_ERS_FORM_PDF:
      return Object.assign({}, state, {
        ersFormPdfLink: action.ersFormPdfLink,
      });
    case types.IS_ADDED:
      return Object.assign({}, state, {
        isAdded: action.isAdded,
      });
      case types.SET_STD_EMPLOYEE_STATEMENT:
      return Object.assign({}, state, { stdEmployeeStatement: action.stdEmployeeStatememt });

    default:
      return state;
  }
};
